import { EventEmitter } from "events";
import TCVelikClient from '@/TCVelikClient/TCVelikClient.js'
import axios from 'axios';
import Vue from 'vue'

class AccountsService extends EventEmitter {
  ACCOUNTS_BASE_URL = process.env.VUE_APP_API_URL;

  accountLogin({ dispatch }, payload) {
    if (payload.success || payload.LoginFailed) {
      return;
    }
    if (!payload.RequestPending) {
      var query = {
        User: payload.userDetails.email,
        Pass: payload.userDetails.password,
        Provider: payload.userDetails.provider
      };

      var headers = {
        'Content-Type': 'application/json',
      }

      payload.RequestPending = true;

      return TCVelikClient.PostRelative("/api/accounts/login", query, { headers: headers })
        .then(function (response) {
          if (response && response.data && response.data.token) {
            localStorage.setItem(location.hostname + "-token", response.data.token);
            var dataMassaged =
            {
              email: response.data.User.Email,
              username: response.data.User.UserName,
              account: response.data.Account.AccountName,
              //password: response.data.User.Password,
              User: response.data.User,
              Roles: response.data.Roles,
              CoreRole: response.data.CoreRole,
              UserPrefs: response.data.UserPrefs
            };



            payload.success = true;
            payload.dataMassaged = payload.userDetails = dataMassaged;
          }
          else {
            dispatch('login', {
              LoginFailed: true,
              notify: payload.notify,
              success: false
            });
          }

          payload.RequestPending = false;
          payload.userDetails = dataMassaged;

          if (response.data != null) {
            localStorage.setItem(location.hostname  + '-fullUserInfo', JSON.stringify(response.data));
          }

          if (window.CefSharp) {
            window.CefSharp.PostMessage({
              op: "LOGGED_IN",
              arg: response.data,
            });
          }

          dispatch('login', payload);

        }, () => {
          dispatch('login', {
            LoginFailed: true,
            notify: payload.notify,
            success: false
          });
        })
        .catch(function (err) {
          alert('Not logged in.');
        });
    }
  }

  shouldCallRefreshUser() {
    const lastCallTimestamp = localStorage.getItem(location.hostname + "-lastCallTimestamp");
    const currentTime = new Date().getTime();

    if (lastCallTimestamp && currentTime - lastCallTimestamp < 5 * 60 * 1000) {
      return false; // Don't call refreshUser as it's been less than 30 minutes
    }

    return true;
  }

  getUserFromLocalStorage() {
    return localStorage.getItem(location.hostname + '-fullUserInfo');
  }

  getUserObjectFromLocalStorageSafe() {
    var userStr = localStorage.getItem(location.hostname + '-fullUserInfo');
    try {
      return JSON.parse(userStr);
    }
    catch {
      return null;
    }
  }

  cleanUserLocalStorageItems() {
    localStorage.removeItem(location.hostname + "-token");
    localStorage.removeItem(location.hostname + '-fullUserInfo');
    localStorage.removeItem(location.hostname + "-userInfo");
    localStorage.removeItem(location.hostname + "-UserEmail");
    localStorage.removeItem(location.hostname + "-UserId");
    localStorage.removeItem(location.hostname + "-lastCallTimestamp");
    localStorage.removeItem(location.hostname + "-anon_authed");
    localStorage.removeItem(location.hostname + "-SelectedAccount");
  }

  refreshUserIfNeeded() {
    if (this.shouldCallRefreshUser()) {
      this.refreshUser();
    }
  }

  refreshUser() {
    return TCVelikClient.PostRelative("/api/Accounts/RefreshUser").then(function (response) {
      if (response.data != null) {
        console.log('refreshUser response:', response.data);
        localStorage.setItem(location.hostname + '-fullUserInfo', JSON.stringify(response.data));
        localStorage.setItem(location.hostname + "-lastCallTimestamp", new Date().getTime());
        console.log('User info stored in localStorage');
      }
    }).catch((err) => {
      console.error('refreshUser error:', err);
      if (err.response.status != undefined) {
        var userInfo = localStorage.getItem(location.hostname + "-fullUserInfo");
        if (userInfo != null && userInfo.length > 0) {
          delete userInfo.User;
          localStorage.setItem(location.hostname + '-fullUserInfo', userInfo);
          localStorage.removeItem(location.hostname + "-token");
        }
      }
    });
  }

  createAccount(payload) {
    return new Promise((resolve, reject) => {
      axios.post('/api/accounts/CreateWithUser', payload.userDetails)
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }

  createAccountOnly(payload) {
    return TCVelikClient.PostRelative("/api/Accounts/Create", payload)
  }

  sendUserInvitation(email) {
    var payLoad = {
      email: email,
      host: window.location.protocol + "//" + window.location.host
    };

    return TCVelikClient.PostRelative(`/api/accounts/InviteUser`, payLoad);
  }

  getUsersData(skipStats) {
    return TCVelikClient.GetRelative("api/user/GetUsers?userId=" + localStorage.getItem("UserId") + "&withStats=" + (!skipStats));
  }

  getUser(userId, tracks, categories, forExercise, catIds) {
    if (!catIds)
      catIds = '';

    var url = `/api/user/GetDetails?userId=${userId}&tracks=${tracks ? encodeURIComponent(tracks) : ''}&categories=${categories ? encodeURIComponent(categories) : ''}&forExercise=${forExercise}&catIds=${catIds}`;
    return TCVelikClient.GetRelative(url);
  }

  getUserBySlug(slug) {
    var url = `/api/user/GetUserBySlug?slug=${slug}`;
    return TCVelikClient.GetRelative(url);
  }

  resetPassword(userId) {
    var headers = {
      'Content-Type': 'application/json',
    }

    return TCVelikClient.PostRelative("/api/Accounts/ResetPassword?userId=" + userId);
  }

  confirmNewPassword(payload) {
    var headers = {
      'Content-Type': 'application/json',
    }
    return TCVelikClient.PostRelative("/api/Accounts/ConfirmNewPassword", payload);
  }

  setInvitation(email, password, confirm, firstName, lastName, pid, step) {
    var query = {
      email: email,
      password: password,
      confirm: confirm,
      pid: pid,
      FirstName: firstName,
      LastName: lastName,
      step: step,
      host: `${window.location.protocol}//${window.location.host}`
    };

    var headers = {
      'Content-Type': 'application/json',
    }

    return TCVelikClient.PostRelative("/api/Accounts/ResetPassword", query, { headers: headers });
  }

  getAccounts() {
    return TCVelikClient.GetRelative("/api/Accounts/GetAccountInformation");
  }

  addOrUpdateBranding(item) {
    return TCVelikClient.PostRelative("/api/Accounts/AddOrUpdateAccountBranding", item);
  }

  updateUser(user) {
    return TCVelikClient.PostRelative("/api/accounts/UpdateUser", user);
  }

  GetStats(from, to, userId) {
    return TCVelikClient.PostRelative("/api/User/GetStats", {
      From: from,
      To: to,
      UserId: userId
    });
  }

  LoginAsUser() {

  }

  async verifyMagicLink(token, campaignName) {
    try {
      // Get email from URL parameters
      const urlParams = new URLSearchParams(window.location.search);
      const email = urlParams.get('email');

      if (!email) {
        throw new Error('Email is required for magic link verification');
      }

      const response = await TCVelikClient.GetRelative(`/api/accounts/VerifyMagicLink?email=${encodeURIComponent(email)}&token=${encodeURIComponent(token)}&campaignName=${campaignName}`);
      
      // Check if user needs to set password
      if (response.data && response.data.NeedsPasswordSetup) {
        // Redirect to password setup page
        window.location.href = response.data.PasswordSetupUrl;
        return;
      }
      
      if (response.data && response.data.token) {
        // Store token first
        localStorage.setItem(location.hostname + "-token", response.data.token);

        // Get user info using the token
        const userResponse = await TCVelikClient.PostRelative("/api/accounts/RefreshUser");
        if (userResponse.data) {
          const dataMassaged = {
            email: userResponse.data.User.Email,
            username: userResponse.data.User.UserName,
            account: userResponse.data.Account.AccountName,
            User: userResponse.data.User,
            Roles: userResponse.data.Roles,
            CoreRole: userResponse.data.CoreRole,
            UserPrefs: userResponse.data.UserPrefs
          };

          // Store all necessary data in localStorage
          localStorage.setItem(location.hostname + '-fullUserInfo', JSON.stringify(userResponse.data));
          localStorage.setItem('user', JSON.stringify(userResponse.data.User));
          localStorage.setItem('account', JSON.stringify(userResponse.data.Account));
          localStorage.setItem(location.hostname + 'roles', JSON.stringify(userResponse.data.Roles));
          localStorage.setItem(location.hostname + 'coreRole', userResponse.data.CoreRole);
          localStorage.setItem(location.hostname + 'userPrefs', JSON.stringify(userResponse.data.UserPrefs));

          // Notify CefSharp if present
          if (window.CefSharp) {
            window.CefSharp.PostMessage({
              op: "LOGGED_IN",
              arg: userResponse.data,
            });
          }

          // Emit login event
          this.emit('login', {
            success: true,
            dataMassaged: dataMassaged,
            userDetails: dataMassaged
          });

          // Reload the page without query strings
          window.location.href = response.data.returnUrl;
        } else {
          throw new Error('Failed to get user info');
        }
      } else {
        this.emit('login', {
          success: false,
          LoginFailed: true,
          notify: {
            title: 'Login Failed',
            text: 'Could not verify your login link.',
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          }
        });
      }
    } catch (error) {
      console.error('Magic link verification failed:', error);
      this.emit('login', {
        success: false,
        LoginFailed: true,
        notify: {
          title: 'Login Failed',
          text: error.message || 'Could not verify your login link.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }
      });
    }
  }

  isAuthenticated() {
    return new Promise((resolve) => {
      const token = localStorage.getItem(location.hostname + '-token');
      const userInfo = localStorage.getItem(location.hostname + '-fullUserInfo');
      
      console.log('isAuthenticated check:', { token: !!token, userInfo: !!userInfo });
      
      // Check for regular authenticated users (with token)
      if (token && userInfo) {
        console.log('Regular authenticated user detected');
        resolve(true);
        return;
      }
      
      // Check for anonymous users (with userInfo but no token)
      if (userInfo) {
        try {
          const userData = JSON.parse(userInfo);
          console.log('User data parsed:', { IsAnonymous: userData.IsAnonymous, User: userData.User });
          
          // If user has IsAnonymous flag, anonymous email, or ANONYMOUS role, consider them authenticated
          if (userData.IsAnonymous || (userData.User && userData.User.isAnonymous) || 
              (userData.CoreRole && userData.CoreRole.toLowerCase() === 'anonymous')) {
            console.log('Anonymous user detected and authenticated');
            Vue.prototype.$isAnonymous = true;
            resolve(true);
            return;
          }
        } catch (error) {
          console.error('Error parsing userInfo:', error);
        }
      }
      
      console.log('No authentication found');
      resolve(false);
    });
  }

  async isFirstTimeSetup() {
    try {
      const response = await TCVelikClient.GetRelative("/api/accounts/IsFirstTimeSetup");
      return response.data.IsFirstTimeSetup;
    } catch (error) {
      console.error('Error checking first time setup:', error);
      return false;
    }
  }
}

export default new AccountsService();
